import service from "../service/preorder";
import CONSTANT from "../constant/preorder";
import STATUS_CODE from "../constant/status_code";
import _ from "underscore";
import { Indicator } from "mint-ui";
export default {
  matchCardTotal({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.matchCardTotal(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_MATCHCARDTOTAL_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_MATCHCARDTOTAL_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  orderCardCheck({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.orderCardCheck(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_ORDERCARDCHECK_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_ORDERCARDCHECK_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  matchOrderCardList({ commit }, params) {
    const { type, data } = params || {};

    //订单适用卡列表
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.matchOrderCardList(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_MATCHORDERCARDLIST_SUCCESS, {
            data: result,
            type,
          });
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_MATCHORDERCARDLIST_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  orderCardListOptimal({ commit }, data) {
    //消费最优卡列表
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.orderCardListOptimal(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_ORDERCARDLISTOPTIMAL_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_ORDERCARDLISTOPTIMAL_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  getPreorderInfo({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.getPreorderInfo(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETPREORDERINFO_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETPREORDERINFO_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  getPreorderSkus({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.getPreorderSkus(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETPREORDERSKUS_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETPREORDERSKUS_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  getPreorderSkuExtend({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.getPreorderSkuExtend(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETPREORDERSKUEXTEND_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETPREORDERSKUEXTEND_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  getFilmOrder({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.getFilmOrder(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETFILMORDER_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETFILMORDER_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  createOrder({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.createOrder(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_CREATEORDER_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_CREATEORDER_ERROR, e);
          // commit('rootApperError', e)
          Indicator.close();
        }
      );
    });
  },
  cashPay({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.cashPay(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_CASHPAY_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_CASHPAY_ERROR, e);
          // commit('rootApperError', e)
          Indicator.close();
        }
      );
    });
  },
  cancelTicketOrder({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.cancelTicketOrder(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_CANCELTICKETORDER_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_CANCELTICKETORDER_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  getDesignatedCards({ commit }, params = {}) {
    Indicator.open();
    const { type, ...data } = params;
    return new Promise((resolve, reject) => {
      return service.getDesignatedCards(data).then(
        (result) => {
          resolve(result);
          // result返回的是数组
          commit(CONSTANT.PREORDER_GETDESIGNATEDCARDS_SUCCESS, {
            data: result,
            optType: type,
          });
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETDESIGNATEDCARDS_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  getPayLimit({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.getPayLimit(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETPAYLIMIT_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETPAYLIMIT_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  orderCouponList({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.orderCouponList(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_ORDERCOUPONLIST_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_ORDERCOUPONLIST_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  getOrderCouponNum({ commit }, data) {
    Indicator.open();
    return new Promise((resolve, reject) => {
      return service.getOrderCouponNum(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETORDERCOUPONNUM_SUCCESS, result);
          Indicator.close();
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETORDERCOUPONNUM_ERROR, e);
          commit("rootApperError", e);
          Indicator.close();
        }
      );
    });
  },
  orderOptimalPay({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.orderOptimalPay(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_ORDEROPTIMALPAY_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_ORDEROPTIMALPAY_ERROR, e);
          commit("rootApperError", e);
        }
      );
    });
  },

  orderCheckPayConfirm({ commit }, params) {
    commit(CONSTANT.PREORDER_ORDERCHECKPAY_SUCCESS_CONFIRM, params);
  },
  orderCheckPay({ commit }, params = {}) {
    Indicator.open();
    const { needConfirm, ...data } = params;

    return new Promise((resolve, reject) => {
      return service.orderCheckPay(data).then(
        (result) => {
          Indicator.close();

          if (result.checkStatus == 0) {
            resolve(result);
            commit(CONSTANT.PREORDER_ORDERCHECKPAY_SUCCESS, {
              ...result,
              needConfirm,
            });
            return result;
          } else {
            reject(result);
          }
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_ORDERCHECKPAY_ERROR, e);
          // commit('rootApperError', e)
          Indicator.close();
        }
      );
    });
  },
  checkLogistics({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.checkLogistics(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_CHECKLOGISTICS_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_CHECKLOGISTICS_ERROR, e);
        }
      );
    });
  },
  getSkuListByPreId({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getSkuListByPreId(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETSKULISTBYPREID_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETSKULISTBYPREID_ERROR, e);
          commit("rootApperError", e);
        }
      );
    });
  },

  preorderVerify({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.preorderVerify(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_PREORDERVERIFY_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_PREORDERVERIFY_ERROR, e);
        }
      );
    });
  },
  getCashPayWay({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getCashPayWay(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETCASHPAYWAY_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETCASHPAYWAY_ERROR, e);
        }
      );
    });
  },
  changeInvoiceInputShow({ commit }, status) {
    commit(CONSTANT.PREORDER_CHANGEINVOICE_INPUT_SUCCESS, status);
  },
  setInvoiceInfo({ commit }, info) {
    commit(CONSTANT.PREORDER_SETINVOICEINFO_SUCCESS, info);
  },
  getTiedProduct({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getTiedProduct(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETTIEDPRODUCT_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETTIEDPRODUCT_ERROR, e);
        }
      );
    });
  },
  getOrderStoreList({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getOrderStoreList(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETORDERSTORELIST_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETORDERSTORELIST_ERROR, e);
        }
      );
    });
  },
  onOrderEvent({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.onOrderEvent(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_ONORDEREVENT_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_ONORDEREVENT_ERROR, e);
        }
      );
    });
  },
  getExamineAgencyListOfPreorder({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getExamineAgencyListOfPreorder(data).then(
        (result) => {
          resolve(result);
          commit(
            CONSTANT.PREORDER_GETEXAMINEAGENCYLISTOFPREORDER_SUCCESS,
            result
          );
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETEXAMINEAGENCYLISTOFPREORDER_ERROR, e);
        }
      );
    });
  },
  getGiftOrderSkuExtend({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getGiftOrderSkuExtend(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETPREORDERSKUEXTEND_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETPREORDERSKUEXTEND_ERROR, e);
        }
      );
    });
  },
  checkGiftOrderLogistics({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.checkGiftOrderLogistics(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_CHECKLOGISTICS_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_CHECKLOGISTICS_ERROR, e);
        }
      );
    });
  },
  getOrderRemindMsg({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getOrderRemindMsg(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.PREORDER_GETORDERREMINDMSG_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.PREORDER_GETORDERREMINDMSG_ERROR, e);
        }
      );
    });
  },
  /*yeoman-template-point-1*/
};
